import React, { useEffect } from 'react';
import WelcomeNote from './welcomeNote/WelcomeNote';
import { Col, Row } from 'react-bootstrap';
import Progress from './progress/Progress';
import { Step } from './progress/progress.type';
import ActionCard from './actionCard/ActionCard';
import DiscoverWhy from './discoverWhy/DiscoverWhy';
import About from './about/About';
import SupportFAQ from './supportFAQ/SupportFAQ';
import { useLazyGetProgressQuery } from 'service/candidateQuery/candidateQuery';
import { getCurrentStep, getProgress } from 'helpers/progress-utils';

function CandidateDashboard() {
  const [gatProgress, { data: progress }] = useLazyGetProgressQuery();

  const steps: Step[] = [
    {
      step: 'Basic Information',
      percentage: getProgress(1, progress),
      stepIndex: 1,
      child: [
        { step: 'Sign up', done: !!progress?.signUp },
        { step: 'Basic Info Form', done: !!progress?.basicInfoForm }
      ]
    },
    {
      step: 'Assessment',
      percentage: getProgress(2, progress),
      stepIndex: 2,
      child: [
        {
          step: 'Complete one Core Basics',
          done: !!progress?.coreBasicsCompleted
        },
        { step: 'Crack with Logic', done: !!progress?.crackedLogic }
      ]
    },
    {
      step: 'Profile Completion',
      percentage: getProgress(3, progress),
      stepIndex: 3,
      child: [
        {
          step: 'Clear Personality Round',
          done: !!progress?.personalityRoundCompleted
        },
        { step: 'Complete your Profile', done: !!progress?.profileCompleted }
      ]
    },
    {
      step: 'Get Hired',
      percentage: getProgress(4, progress),
      stepIndex: 4,
      child: [
        {
          step: 'Get Shortlisted for a Job',
          done: !!progress?.shortlistedForJob
        },
        { step: 'Stay tuned for a match', done: !!progress?.matchFound },
        { step: 'Get Hired', done: !!progress?.getHired }
      ]
    }
  ];

  const currentStep: string = getCurrentStep(progress);
  useEffect(() => {
    gatProgress()
      .unwrap()
      .catch(err => console.log(err));
  }, []);
  return (
    <div className="pb-5">
      <Row className="g-3">
        <Col xs={12}>
          <WelcomeNote />
        </Col>
        <Col xs={12}>
          <Progress steps={steps} />
        </Col>
        <Col xs={12}>
          <ActionCard currentStep={currentStep} />
        </Col>
        <Col xs={12}>
          <DiscoverWhy />
        </Col>
        <Col xs={12}>
          <About />
        </Col>
        <Col xs={12}>
          <SupportFAQ />
        </Col>
      </Row>
    </div>
  );
}

export default CandidateDashboard;
